import React, { useState, useRef, useEffect } from "react";
import InnoIcons from "@InnoIcons/";
import SC from "./style";
import { InputField } from "@components/";
import { use } from "react";
import theme from "@theme/";

const NumberFilterDropdown = ({
  label = "Number",
  selectedHeaderId,
  onHeaderChange,
  selectedValue = "",
  headerOptionsValueName = "Number",
  onValueChange,
  minWidth = "250px",
  buttonWidth = "200px",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
  const [inputValue, setInputValue] = useState(selectedValue);
  const dropdownRef = useRef();

  // Operator options
  const headerOptions = [
    { id: "equals", label: `${headerOptionsValueName} = (equals)` },
    { id: "lessThanEqual", label: `${headerOptionsValueName} <= (less than)` },
    {
      id: "greaterThanEqual",
      label: `${headerOptionsValueName} >= (greater than)`,
    },
  ];

  const selectedHeader = headerOptions.find((h) => h.id === selectedHeaderId);

  const handleUpdate = () => {
    if (!inputValue || inputValue <= 0) {
      onValueChange?.(null); // reset if invalid
    } else {
      onValueChange?.(inputValue);
    }
    setIsOpen(false);
    setIsHeaderExpanded(false);
  };

  const handleInputChange = (name, val) => {
    if (/^\d*\.?\d*$/.test(val)) setInputValue(val);
  };

  const handleHeaderClick = (headerId) => {
    onHeaderChange(headerId);
    setIsHeaderExpanded(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setIsHeaderExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setInputValue(selectedValue);
  }, [selectedValue]);

  return (
    <SC.DropdownContainer ref={dropdownRef}>
      <SC.DropdownButton
        minWidth={buttonWidth}
        isOpen={isOpen}
        isActive={!!selectedValue && Number(selectedValue) > 0}
        onClick={() => setIsOpen((p) => !p)}
      >
        {selectedValue && Number(selectedValue) > 0
          ? `${label}: ${
              selectedHeader?.id === "equals"
                ? "="
                : selectedHeader?.id === "lessThanEqual"
                ? "<="
                : selectedHeader?.id === "greaterThanEqual"
                ? ">="
                : ""
            } ${inputValue} `
          : `${label}`}
        <SC.ChevronIcon
          size={14}
          isOpen={isOpen}
          isActive={!!selectedValue && Number(selectedValue) > 0}
        />
      </SC.DropdownButton>

      {isOpen && (
        <SC.DropdownMenu isOpen={isOpen} minWidth={minWidth}>
          {/* Header/Operator */}
          <SC.DropdownHeader
            isClickable
            onClick={() => setIsHeaderExpanded((p) => !p)}
          >
            <SC.HeaderText>
              {selectedHeader?.label || "Select Condition"}
            </SC.HeaderText>
            <SC.HeaderChevron isExpanded={isHeaderExpanded} />
          </SC.DropdownHeader>

          <SC.HeaderOptionsContainer isVisible={isHeaderExpanded}>
            {headerOptions.map((header) => (
              <SC.HeaderOption
                key={header.id}
                isSelected={header.id === selectedHeaderId}
                onClick={() => handleHeaderClick(header.id)}
              >
                {header.label}
              </SC.HeaderOption>
            ))}
          </SC.HeaderOptionsContainer>

          {/* Input + Unit */}
          <div
            style={{ display: "flex", alignItems: "center", margin: "30px 0" }}
          >
            <InputField
              name="number"
              type="number"
              placeholder="Enter no."
              value={inputValue}
              onChange={handleInputChange}
              style={{ width: "100%", height: "35px", borderRadius: "5px" }}
            />
          </div>

          {/* Footer */}
          <SC.DropdownFooter
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <SC.UpdateButton
              onClick={handleUpdate}
              style={{
                background: theme.gradient.themeGradient,
                color: "#fff",
              }}
            >
              Update
            </SC.UpdateButton>

            <SC.ClearAllButton
              onClick={() => {
                setInputValue(""); // clear input
                onValueChange?.(null); // reset backend filter
                setIsOpen(false);
                setIsHeaderExpanded(false);
              }}
            >
              Clear
            </SC.ClearAllButton>
          </SC.DropdownFooter>
        </SC.DropdownMenu>
      )}
    </SC.DropdownContainer>
  );
};

export default NumberFilterDropdown;
